import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { setAuthToken } from "@/lib/api";

/**
 * AuthCallback — exchanges the Emergent session_id (found in URL hash) for a
 * persistent app session, then routes into the dashboard.
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;

      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }

      const remember = localStorage.getItem("em_remember") !== "0";

      try {
        const res = await api.post("/auth/session", {
          session_id: sessionId,
          remember,
        });
        if (res.data?.session_token) setAuthToken(res.data.session_token);
        setUser(res.data);
        // clear the hash and go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    };

    run();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505]">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-white/10 border-t-[#1a3fd1]" />
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">
          Establishing secure session…
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
